import React from "react";
import { Modal, Button } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
function CustomModal({ show, header, children, handleClose, size }) {
  return (
    <div>
      <Modal
        show={show}
        // backdrop="static"
        centered
        size={size ? size : "lg"}
        onHide={handleClose}
      >
        <Modal.Header className="flex-r d-flex">
          <button onClick={handleClose}>
            <AiOutlineClose size={"1.5rem"} />
          </button>
          <Modal.Title className="fs-14">{header}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
      </Modal>
    </div>
  );
}

export default CustomModal;
